// extracted by mini-css-extract-plugin
export default {"container":"Fq-z","brandName":"Gq-z","productName":"Hq-z","productNamePdpEnhancements":"Iq-z","breakLongProductName":"Jq-z"};